import { useLocationsRetrieve } from "@sidegigllc/api/client";
import { useIsAdmin } from "domains/auth";
import { useCanManageJobsPlan } from "domains/hire/hooks/useCanManageJobsPlan";
import { jobsGateFor } from "domains/hire/jobsPlan";

/**
 * The one place the Jobs gate is computed: what stands between this person and the Jobs features at a location
 * (`gate`: start the trial, resubscribe, ask an admin, or null), with what it came from. Loaders can't call hooks,
 * so the route loader and JobDetails use the non-hook `isJobsLocked` instead.
 */
export const useJobsGateState = (locationId: number) => {
  const { data: location } = useLocationsRetrieve(locationId);
  const isStaff = useIsAdmin();
  const canManage = useCanManageJobsPlan(locationId);
  const status = location?.jobs_subscription;
  return { location, status, isStaff, canManage, gate: jobsGateFor(status, { isStaff, canManage }) };
};
